import { render, staticRenderFns } from "./EnrollmentBatchManage.vue?vue&type=template&id=e480fc64&"
import script from "./EnrollmentBatchManage.vue?vue&type=script&lang=js&"
export * from "./EnrollmentBatchManage.vue?vue&type=script&lang=js&"
import style0 from "./EnrollmentBatchManage.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports